/** Canonical NitroMule brand assets (main site — not portals). */

export const NM_WORDMARK_LIGHT_URL = '/branding/wordmarks/nitromule-wordmark-light.svg';
export const NM_WORDMARK_DARK_URL = '/branding/wordmarks/nitromule-wordmark-dark.svg';
/** Raster fallback for email clients that do not render SVG. */
export const NM_WORDMARK_LIGHT_PNG_URL = '/branding/wordmarks/nitromule-wordmark-light.png';
export const NM_WORDMARK_DARK_PNG_URL = '/branding/wordmarks/nitromule-wordmark-dark.png';
export const NM_SITE_ICON_URL = '/branding/nitromule-icon.svg';
/** Raster fallback for apple-touch-icon, Open Graph, and desktop packaging. */
export const NM_SITE_ICON_PNG_URL = '/branding/nitromule-icon.png';
/** Prevents browsers from falling back to /favicon.ico when a portal has no site icon. */
export const BLANK_FAVICON_HREF = 'data:,';
export const NM_MASCOT_URL = '/branding/nitromule-mascot.png';

export function siteIconLinkType(url) {
  const path = String(url || '').split('?')[0].toLowerCase();
  if (path.endsWith('.svg')) return 'image/svg+xml';
  if (path.endsWith('.png')) return 'image/png';
  if (path.endsWith('.ico')) return 'image/x-icon';
  return '';
}

/** Primary accent color for main-site UI (not portal theme_color). */
export const NM_PRIMARY_COLOR = '#006BC2';
export const NM_PRIMARY_LIGHT_TINT = '#e6f0ff';
export const NM_PRIMARY_LIGHTER_TINT = '#f0f7ff';

/** Header logo for light UI chrome. */
export const NM_HEADER_LOGO_URL = NM_WORDMARK_LIGHT_URL;
/** Header logo for dark UI chrome. */
export const NM_HEADER_LOGO_DARK_URL = NM_WORDMARK_DARK_URL;
